module.exports = __webpack_public_path__ + "static/media/logo.c8770a4a.png";